'use client';

import { useEffect, useState } from 'react';

import { Button } from '@/components/button';

import { CalendarItem } from './item';
import { CalendarSkeleton } from './skeleton';

const DEFAULT_VISIBLE = 4;

export const CalendarClient = () => {
  const [events, setEvents] = useState(null);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    let active = true;

    fetch('/api/circle/events')
      .then((response) => response.json())
      .then((data) => {
        if (active) {
          setEvents(Array.isArray(data?.events) ? data.events : []);
        }
      })
      .catch((error) => {
        console.error(error);

        if (active) {
          setEvents([]);
        }
      });

    return () => {
      active = false;
    };
  }, []);

  if (events === null) {
    return <CalendarSkeleton />;
  }

  if (events.length === 0) {
    return null;
  }

  const visibleEvents = showAll ? events : events.slice(0, DEFAULT_VISIBLE);

  return (
    <>
      <div className="calendar__content">
        {visibleEvents.map((event) => {
          return <CalendarItem key={event.id} event={event} />;
        })}
      </div>

      {!showAll && events.length > DEFAULT_VISIBLE ? (
        <div className="calendar__more">
          <Button
            theme="black-border"
            onClick={() => {
              setShowAll(true);
            }}
          >
            Afficher tous les événements
          </Button>
        </div>
      ) : null}
    </>
  );
};
